<template>
  <div class="setting-wizard">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />
    <div class="setting-wizard__head">
      <p>セットアップ</p>
      <button @click="closeSettingWizardPanel">
        <i class="material-icons">close_black</i>
      </button>
    </div>
    <div v-if="!isSocketEnabled && wizardInfoName === 'parent'" class="setting-wizard__check-setting" :class="{'loading': isLoading}">
      <button @click="fetchSettingWizard()">
        <span>設定チェック</span>
        <img class="loading" src="../../assets/images/loading.svg" />
        <img class="loading_done" src="../../assets/images/loading_done.svg" />
      </button>
    </div>
    <div v-if="wizardInfoName === 'parent'" class="setting-wizard__body">
      <div class="setting-wizard__step accordion" role="tablist">
        <!-- item -->
        <div class="item" :class="{completed: isCompletedStep(STEP1)}">
          <div
            class="item__head d-flex align-items-center"
            v-b-toggle.accordion-1
            role="tab"
          >
            <div class="num">1.</div>
            <div class="label">+Hubへようこそ</div>
            <div class="check"><i class="material-icons">done</i></div>
          </div>
        </div>
        <!-- item -->
        <div class="item" :class="{completed: isCompletedStep(STEP2)}">
          <div
            class="item__head d-flex align-items-center"
            role="tab"
            @click="changeCurrentStep(STEP2)"
          >
            <div class="num">2.</div>
            <div class="label">+Hubの全体設定</div>
            <div class="check"><i class="material-icons">done</i></div>
          </div>
          <b-collapse
            class="item__body"
            id="accordion-2"
            :visible="stepCurrent === STEP2"
            accordion="my-accordion"
            role="tabpanel"
          >
            <p>
              まずは
              <a
                href="javascript:void(0)"
                @click="gotoTargetPage($event, 'GeneralSetting')"
                >全体設定</a
              >
              を行ってください。
            </p>
          </b-collapse>
        </div>
        <!-- item -->
        <div class="item" :class="{completed: isCompletedStep(STEP3)}">
          <div
            class="item__head d-flex align-items-center"
            role="tab"
            @click="changeCurrentStep(STEP3)"
          >
            <div class="num">3.</div>
            <div class="label">アプリごとの設定</div>
            <div class="check"><i class="material-icons">done</i></div>
          </div>
          <b-collapse
            class="item__body"
            id="accordion-3"
            :visible="stepCurrent === STEP3"
            accordion="my-accordion"
            role="tabpanel"
          >
            <p class="mb-1">
              <a href="javascript:void(0)" @click="gotoTargetPage($event, 'TaskTypeSetting')"
                >t-Sort仕分けの設定</a
              >を行ってください。<br />
              各設定項目については以下をご参照ください。
            </p>
            <div class="setting-wizard__step setting-wizard__step--small">
              <div class="item" :class="{completed: isCompletedStep(STEP3)}">
                <div
                  class="item__head item__head--link d-flex align-items-center"
                  @click="changeInfoWizard('t-sort')"
                >
                  <div class="check">
                    <i class="material-icons">done</i>
                  </div>
                  <div class="label">t-Sortで商品仕分け</div>
                  <i class="arrow material-icons">keyboard_arrow_right</i>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
        <!-- item -->
        <div class="item" :class="{completed: isCompletedStep(STEP4)}">
          <div
            class="item__head d-flex align-items-center"
            role="tab"
            @click="changeCurrentStep(STEP4)"
          >
            <div class="num">4.</div>
            <div class="label">アップロード</div>
            <div class="check"><i class="material-icons">done</i></div>
          </div>
          <b-collapse
            class="item__body"
            id="accordion-4"
            :visible="stepCurrent === STEP4"
            accordion="my-accordion"
            role="tabpanel"
          >
            <p class="mb-1">
              マッピングを参照しながらデータを作成し、
              <a
                href="javascript:void(0)"
                @click="gotoTargetPage($event, 'CsvUpload')"
                >アップロード</a
              >画面からデータをアップロードしてください。<br />
              データの形式は以下をご参照ください。
            </p>
            <div class="setting-wizard__step setting-wizard__step--small">
              <div  v-for="(upload, idx) in this.csvUpload" :key="idx" class="item" :class="{completed: upload.hasUploadedData}" @click="changeInfoWizard(upload.csvNo)">
                <div
                  class="item__head item__head--link d-flex align-items-center"
                >
                  <div class="check">
                    <i class="material-icons">done</i>
                  </div>
                  <div class="label">{{upload.type}}</div>
                  <i class="arrow material-icons">keyboard_arrow_right</i>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
        <!-- item -->
        <div class="item" :class="{completed: isCompletedStep(STEP5)}">
          <div
            class="item__head d-flex align-items-center"
            role="tab"
            @click="changeCurrentStep(STEP5)"
          >
            <div class="num">5.</div>
            <div class="label">RCSの起動</div>
            <div class="check"><i class="material-icons">done</i></div>
          </div>
          <b-collapse
            class="item__body"
            id="accordion-5"
            :visible="stepCurrent === STEP5"
            accordion="my-accordion"
            role="tabpanel"
          >
            <p>
              デスクトップにあるショートカットからRCSアプリを起動してください。
            </p>
            <ol class="mb-3">
              <li>RCS起動</li>
              <li>RCS画面で「全電力オン」ボタンをクリック（ロボットの電力オン）</li>
              <li>RCS画面で「スタート」ボタンをクリック（仕分け受付開始）</li>
              <li v-if="!isSocketEnabled">
                この画面に戻り、上の「設定チェック」ボタンをクリックして通信できているか確認
              </li>
            </ol>
            <div class="setting-wizard__step setting-wizard__step--small mb-3">
              <div v-for="(rcs, idx) in mstRcs" :key="idx" class="item" :class="{completed: rcs.rcsEmergencyStopFlag === RCS_EMERGENCY_STOP_FLAG_ERROR_RECOVERY}">
                <div class="item__head item__rcs d-flex align-items-center">
                  <div class="check">
                    <i class="material-icons">done</i>
                  </div>
                  <div class="label">{{rcs.rcsName | formatRcsName(rcs.rcsNo)}}</div>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
        <!-- item -->
        <div class="item" :class="{completed: isCompletedStep(STEP6)}">
          <div
            class="item__head d-flex align-items-center"
            role="tab"
            @click="changeCurrentStep(STEP6)"
          >
            <div class="num">6.</div>
            <div class="label">デバイス設定</div>
            <div class="check"><i class="material-icons">done</i></div>
          </div>
          <b-collapse
            class="item__body"
            id="accordion-6"
            :visible="stepCurrent === STEP6"
            accordion="my-accordion"
            role="tabpanel"
          >
            <p>
              <span v-if="authMode == true" v-frag>
                ・各投入口の端末からデバイス申請を行ってください。<br /><br />
                ・
                <a
                  href="javascript:void(0)"
                  @click="gotoTargetPage($event, 'DeviceMaster')"
                  >デバイスマスタ</a>画面で「承認リクエスト」内に届いたリクエストを承認してください。<br /><br />
                ・認証を受けた端末でログインをし、+Hub Scanの設定画面からインダクションを設定してください。<br />
              </span>
              <span v-else v-frag>
                +Hub Scanの設定画面からインダクションを設定してください。<br />
              </span>
            </p>
            <br />
            <h1 class="mb-3">最後に</h1>
            <p class="mb-3">
              スキャン・ロボットの試運転をして連動するか確認し、<a href="javascript:void(0)" @click="gotoTargetPage($event, 'TaskStatement')">タスク明細</a>の更新が確認できたら設定完了です。
            </p>
            <button class="btn-check btn-check--hover" @click="closeSettingWizardPanel">閉じる</button>
          </b-collapse>
        </div>
      </div>
      <a href="https://usersite.plus-hub.com" target="_blank" rel="noopener noreferrer" class="setting-wizard__help" :class="{'loading': !isLoading}">
        <span>?</span>より詳細なヘルプページ
      </a>
    </div>
    <div v-else-if="wizardInfoName !== 'parent'" class="setting-wizard__body">
      <button class="setting-wizard__back" @click="changeInfoWizard('parent')">
        <i class="material-icons">keyboard_arrow_left</i>
        <span v-if="wizardInfoName === 't-sort'">アプリごとの設定</span>
        <span v-else>アップロード</span>
      </button>
      <!-- t-sort -->
      <div v-if="wizardInfoName === 't-sort'" class="setting-wizard__child">
        <h1 class="mb-4">
          t-Sortで商品仕分け
        </h1>
        <div class="mb-4">
          <p>
            タスクタイプの設定を基準に必要な設定項目が表示されます。以下の順番で設定してください。
          </p>
        </div>
        <h1 class="mb-4">
          <span class="num">1</span><span>タスクタイプ</span>
        </h1>
        <div class="pl-2 mb-4">
          <h1>業務タイプの設定</h1>
          <p>
            取引先ごとや通常時期/過渡期など、状況別の設定を複数持つことができます。
          </p>
          <p>
            タスクタイプの設定後に設定が必要なマスタが判明します。順番に設定してください。
          </p>
          <p>
            設定が終わったタスクタイプは有効にしてください。
          </p>
        </div>
        <h1 class="mb-4">
          <span class="num">2</span><span>データの利用有無</span>
        </h1>
        <div class="pl-2 mb-4">
          <p>利用するデータを選択してください。</p>
        </div>
        <h1 class="mb-4">
          <span class="num">3</span>
          <span>タスク明細作成時の厳密性</span>
        </h1>
        <div class="pl-2 mb-4">
          <p>エラーチェックを行うか選択してください。<br />※本項目がない場合は設定の必要はありません。</p>
        </div>
        <h1 class="mb-4">
          <span class="num">4</span>
          <span>タスク明細作成時の登録順</span>
        </h1>
        <div class="pl-2 mb-4">
          <p>「タスク明細」に登録する作業指示データとマスタの優先度を選択してください。<br />※本項目がない場合は設定の必要はありません。</p>
        </div>
        <h1 class="mb-4">
          <span class="num">5</span>
          <span>伝票スキャン</span>
        </h1>
        <div class="pl-2 mb-4">
          <p>伝票スキャンを行うか選択してください。<br />※本項目がない場合は設定の必要はありません。</p>
        </div>
        <h1 class="mb-4 pb-2">
          <span class="num">6</span><span>データフォーマット設定</span>
        </h1>
        <div class="pl-2">
          <h1 class="mb-3">
            <span class="num num--outline">1</span
            ><span>CSVファイルの設定</span>
          </h1>
          <p class="mb-4">
            各項目の形式を設定して、保存をしてください。
          </p>
          <p class="sub-title">区切り文字</p>
          <p>CSVファイルで使用する区切り文字を指定してください。</p>
          <p class="sub-title">プレフィックス</p>
          <p>CSVファイルアップロード/ダウンロード時に種類を特定するため、ファイル名の先頭文字を1〜32文字で設定します。_（アンダースコア）/（スラッシュ）-（ハイフン）＼（バックスラッシュ）は使用不可です。</p>
          <p class="sub-title">1行目のヘッダ</p>
          <p>アップロード/ダウンロードするCSVファイルの1行目にヘッダを含む場合は指定してください。</p>
          <h1 class="mb-3">
            <span class="num num--outline">2</span><span>マッピング</span>
          </h1>
          <p>
            1.の変更分を保存してから、マッピング設定を行ってください。
          </p>
          <p>
            必須と付いている「未設定」のボタンを押して、マッピング画面へ移動してください。「貴社の情報」と「+Hub BASE」の情報を同一項目として関連付ける設定です。
          </p>
          <img class="mb-4 pb-2" src="../../assets/images/setting-wizard/wizard-tsort-1.svg" />
          <h1>Step1 <br />
              貴社の情報を入力</h1>
          <p>
            「{{wmsName}} の定義」画面で+Hubに渡す「貴社の情報」の列名を順番通りに登録してください。<br />
            登録が完了したら次の「+Hub に紐づけ」に進んでください。<br />
            並べ替えは設定後に変更も可能です。
          </p>
          <img class="mb-4 pb-2" src="../../assets/images/setting-wizard/wizard-tsort-2.svg" />
          <h1>Step2 <br />
              +Hub に紐づけ</h1>
          <p>
            「{{ isName }} に紐づけ」画面で+Hubに渡す項目を設定してください。<br />
            設定できる項目は2種 <br />
            ・「{{wmsName}} の定義」で設定した項目 <br />
            ・指定の初期値 <br />
            両方設定することもできます。
          </p>
          <img class="mb-3" src="../../assets/images/setting-wizard/wizard-tsort-3.svg" />
          <p>
            ※「CSV実績データ」のみ+Hubのデータをダウンロードする時のフォーマット設定のため、Step1が省略されます。
          </p>
        </div>
      </div>
      <!-- master item -->
      <div v-else-if="wizardInfoName === 'item'" class="setting-wizard__child wizard-info">
        <h1 class="mb-4">商品マスタ</h1>
        <h1 class="mb-4">
          <span class="num">1</span><span>アップロードデータの作成</span>
        </h1>
        <div class="pl-2 mb-4">
          <p>
            アップロードするファイルの列順は「{{wmsName}}の定義」と揃えてください。
          </p>
          <p>
            <a
              href="javascript:void(0)"
              @click="gotoTargetPage($event, 'ItemMapping')"
              >商品マスタのマッピング</a
            >を参照しながらアップロードデータを作成してください。
          </p>
        </div>
        <h1 class="mb-4">
          <span class="num">2</span><span>アップロード</span>
        </h1>
        <p>
          <a
            href="javascript:void(0)"
            @click="gotoTargetPage($event, 'CsvUpload')"
            >アップロード</a
          >画面で作成したファイルをアップロードしてください。<br />
          完了したら、<a
            href="javascript:void(0)"
            @click="gotoTargetPage($event, 'ItemMaster')"
            >商品マスタ</a
          >画面を確認し、アップロードした情報が反映されていることを確認してください。
        </p>
        <button
          class="btn-check btn-check--hover btn-check--center"
          @click="handleNextStep('item')"
        >
        {{ handleShowNextOrCloseButton('item') }}
        </button>
      </div>
      <!-- master chute -->
      <div v-else-if="wizardInfoName === 'chute'" class="setting-wizard__child wizard-info">
        <h1 class="mb-4">シュートマスタ</h1>
        <h1 class="mb-4">
          <span class="num">1</span><span>アップロードデータの作成</span>
        </h1>
        <div class="pl-2 mb-4">
          <p>
            アップロードするファイルの列順は「{{wmsName}}の定義」と揃えてください。
          </p>
          <p>
            <a
              href="javascript:void(0)"
              @click="gotoTargetPage($event, 'ChuteMapping')"
              >シュートマスタのマッピング</a
            >を参照しながらアップロードデータを作成してください。<br/>
          </p>
        </div>
        <h1 class="mb-4">
          <span class="num">2</span><span>アップロード</span>
        </h1>
        <p>
          <a
            href="javascript:void(0)"
            @click="gotoTargetPage($event, 'CsvUpload')"
            >アップロード</a
          >画面で作成したファイルをアップロードしてください。<br />
          完了したら、<a
            href="javascript:void(0)"
            @click="gotoTargetPage($event, 'ChuteMaster')"
            >シュートマスタ</a
          >画面を確認し、アップロードした情報が反映されていることを確認してください。
        </p>
        <button
          class="btn-check btn-check--hover btn-check--center"
          @click="handleNextStep('chute')"
        >
        {{ handleShowNextOrCloseButton('chute') }}
        </button>
      </div>
      <!-- master shop -->
      <div v-else-if="wizardInfoName === 'shop'" class="setting-wizard__child wizard-info">
        <h1 class="mb-4">店舗マスタ</h1>
        <h1 class="mb-4">
          <span class="num">1</span><span>アップロードデータの作成</span>
        </h1>
        <div class="pl-2 mb-4">
          <p>
            アップロードするファイルの列順は「{{wmsName}}の定義」と揃えてください。
          </p>
          <p>
            <a
              href="javascript:void(0)"
              @click="gotoTargetPage($event, 'ShopMapping')"
              >店舗マスタのマッピング</a
            >を参照しながらアップロードデータを作成してください。<br/>
          </p>
        </div>
        <h1 class="mb-4">
          <span class="num">2</span><span>アップロード</span>
        </h1>
        <p>
          <a
            href="javascript:void(0)"
            @click="gotoTargetPage($event, 'CsvUpload')"
            >アップロード</a
          >画面で作成したファイルをアップロードしてください。<br />
          完了したら、<a
            href="javascript:void(0)"
            @click="gotoTargetPage($event, 'ShopMaster')"
            >店舗マスタ</a
          >画面を確認し、アップロードした情報が反映されていることを確認してください。
        </p>
        <button
          class="btn-check btn-check--hover btn-check--center"
          @click="handleNextStep('shop')"
        >
        {{ handleShowNextOrCloseButton('shop') }}
        </button>
      </div>
      <!-- master sorting -->
      <div v-else-if="wizardInfoName === 'sorting'" class="setting-wizard__child wizard-info">
        <h1 class="mb-4">仕分けマスタ</h1>
        <h1 class="mb-4">
          <span class="num">1</span><span>アップロードデータの作成</span>
        </h1>
        <div class="pl-2 mb-4">
          <p>
            アップロードするファイルの列順は「{{wmsName}}の定義」と揃えてください。
          </p>
          <p>
            <a
              href="javascript:void(0)"
              @click="gotoTargetPage($event, 'SortingMapping')"
              >仕分マスタのマッピング</a
            >を参照しながらアップロードデータを作成してください。<br/>
          </p>
        </div>
        <h1 class="mb-4">
          <span class="num">2</span><span>アップロード</span>
        </h1>
        <p>
          <a
            href="javascript:void(0)"
            @click="gotoTargetPage($event, 'CsvUpload')"
            >アップロード</a
          >画面で作成したファイルをアップロードしてください。<br />
          完了したら、<a
            href="javascript:void(0)"
            @click="gotoTargetPage($event, 'SortingMaster')"
            >仕分けマスタ</a
          >画面を確認し、アップロードした情報が反映されていることを確認してください。
        </p>
        <button
          class="btn-check btn-check--hover btn-check--center"
          @click="handleNextStep('sorting')"
        >
        {{ handleShowNextOrCloseButton('sorting') }}
        </button>
      </div>
      <!-- master task -->
      <div v-else-if="wizardInfoName === 'task'" class="setting-wizard__child wizard-info">
        <h1 class="mb-4">作業指示データ</h1>
        <h1 class="mb-4">
          <span class="num">1</span><span>アップロードデータの作成</span>
        </h1>
        <div class="pl-2 mb-4">
          <p>
            アップロードするファイルの列順は「{{wmsName}}の定義」と揃えてください。
          </p>
          <p>
            <a
              href="javascript:void(0)"
              @click="gotoTargetPage($event, 'TaskMapping')"
              >作業指示データのマッピング</a
            >を参照しながらアップロードデータを作成してください。<br/>
          </p>
        </div>
        <h1 class="mb-4">
          <span class="num">2</span><span>アップロード</span>
        </h1>
        <p>
          <a
            href="javascript:void(0)"
            @click="gotoTargetPage($event, 'CsvUpload')"
            >アップロード</a
          >画面で作成したファイルをアップロードしてください。<br />
          完了したら、<a
            href="javascript:void(0)"
            @click="gotoTargetPage($event, 'BatchControl')"
            >バッチ</a
          >画面を確認し、アップロードした情報が反映されていることを確認してください。
        </p>
        <button
          class="btn-check btn-check--hover btn-check--center"
          @click="handleNextStep('task')"
        >
          {{ handleShowNextOrCloseButton('task') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import RouterUtils from '../../_helpers/router.util'
import { mapState, mapActions, mapGetters } from 'vuex'
import { SettingWizardStep } from '../../enums/setting-wizard-step.enums.js'
import Loading from 'vue-loading-overlay'
const RCS_EMERGENCY_STOP_FLAG_ERROR_RECOVERY = 0
export default {
  components: {
    Loading
  },
  props: {
    active: Number,
    fetchNewSWData: Boolean
  },
  data() {
    return {
      // eslint-disable-next-line no-undef
      authMode: config.AUTH_MODE,
      wizardInfoName: 'parent', // ウィザード情報名
      infoSettingWizard: {},
      stepCurrent: 0,
      hubId: null,
      mstRcs: [],
      csvUpload: [],
      isLoading: false,
      wmsName: '',
      isName: '',
      STEP1: SettingWizardStep.START_SETUP_STEP,
      STEP2: SettingWizardStep.GENERAL_SETTING_STEP,
      STEP3: SettingWizardStep.APP_SETTING_STEP,
      STEP4: SettingWizardStep.UPLOAD_STEP,
      STEP5: SettingWizardStep.START_RCS_STEP,
      STEP6: SettingWizardStep.DEVICE_SETTING_STEP,
      isCloseButton: false,
      RCS_EMERGENCY_STOP_FLAG_ERROR_RECOVERY: RCS_EMERGENCY_STOP_FLAG_ERROR_RECOVERY
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('settingWizardStore', ['getSetupData']),
    ...mapGetters('settingWizardStore', ['getInfoSteps']),
    ...mapGetters('socket', ['isSocketEnabled']),
    ...mapGetters('socket', ['isFetchSettingWizardFlag'])
  },
  async mounted() {
    this.getSettingName()
    this.infoSettingWizard = this.getSetupData
    this.standardizedDataSettingWizard()
  },
  watch: {
    async isFetchSettingWizardFlag(newValue, oldValue) {
      if (newValue && this.active) {
        await this.fetchSettingWizard(true)
      }
      this.setFetchSettingWizardFlag(false)
    },
    '$store.state.reconnectedFlag': async function(newValue) {
      if (newValue && this.active) {
        await this.fetchSettingWizard(true)
        this.setFetchSettingWizardFlag(false)
      }
    },
    active: async function() {
      // ウィザードを開いたときにデータをフェッチします。
      if (this.active) {
        this.wizardInfoName = 'parent'
        this.stepCurrent = 0
        if (this.fetchNewSWData) {
          await this.fetchSettingWizard(true)
        }
      } else {
        // 値を共通ヘッダーウォッチャーにリセットします
        this.updateSetupStatus(-1)
      }
    },
    getSetupData: {
      deep: true,
      handler: function(newVal) {
        this.infoSettingWizard = newVal
        this.standardizedDataSettingWizard()
      }
    }
  },
  filters: {
    formatRcsName(rcsName, rcsNo) {
      return rcsName ? 'RCS ' + rcsNo + ' / ' + rcsName : 'RCS ' + rcsNo
    }
  },
  methods: {
    /**
     * アクティブなステップを変更
     * @param {number} step - ステップ
     */
    changeCurrentStep(step) {
      if (this.stepCurrent === step) {
        this.stepCurrent = 0
        return
      }
      this.stepCurrent = step
    },
    ...mapActions('settingWizardStore', ['getSetupDataSettingWizard', 'updateSetupStatus', 'updateMenuStatus']),
    ...mapActions('socket', ['setFetchSettingWizardFlag']),
    ...mapGetters('setting', ['getSetting']),
    /**
     * データ設定ウィザードの取得。
     * @param {boolean} notLoading - フェッチデータがロードされていません
     */
    async fetchSettingWizard(notLoading = false) {
      if (!notLoading) {
        this.isLoading = true
      }
      await this.getSetupDataSettingWizard({hubId: this.user.deptId}).catch((error) => { console.log(error) })
      this.getSettingName()
      this.isLoading = false
    },
    /**
     * 定型データ設定ウィザード。
     */
    standardizedDataSettingWizard() {
      if (!this.infoSettingWizard) {
        return
      }

      // RCS を更新する。
      if (this.infoSettingWizard.mstRcs) {
        this.mstRcs = this.infoSettingWizard.mstRcs
      }

      // csv アップロードの更新。
      if (this.infoSettingWizard.csvUpload) {
        this.csvUpload = this.infoSettingWizard.csvUpload
      }
    },
    /**
     * 設定ウィザード パネルを閉じます。
     */
    closeSettingWizardPanel() {
      this.updateMenuStatus(0)
      this.$emit('close-setting-wizard-panel', false)
    },
    /**
     * ターゲットページに移動
     * @param {string} ページ名
     */
    gotoTargetPage(e, routeName) {
      if (e && e.preventDefault) {
        e.preventDefault()
      }
      RouterUtils.goToRouterName(routeName)
    },
    /**
     * 情報の変更ウィザード
     * @param {string} name ウィザード情報名
     */
    changeInfoWizard(name) {
      this.wizardInfoName = name
    },
    /**
     * チェックステップが完了しました
     * @param {number} step 数段
     * @return {boolean} {true：存在、 false：存在しなかった。}
     */
    isCompletedStep(step) {
      return this.getInfoSteps.includes(step)
    },
    /**
     * マスターをチェックして正しいボタンを表示する
     * @param {string} item マスター
     * @return {string} ボタン名。
     */
    handleShowNextOrCloseButton(item) {
      let lastItem = this.infoSettingWizard.csvUpload.length - 1
      let buttonName = ''
      if (this.infoSettingWizard.csvUpload[lastItem].csvNo === item || !this.infoSettingWizard.csvUpload.find(obj => obj.csvNo === item)) {
        this.isCloseButton = true
        buttonName = '閉じる'
      } else {
        this.isCloseButton = false
        buttonName = '次へ'
      }
      return buttonName
    },
    /**
     * マスターをチェックして変更ステップを処理する
     * @param {string} item マスター
     */
    handleNextStep(item) {
      let page = this.infoSettingWizard.csvUpload.findIndex(obj => obj.csvNo === item)
      if (this.isCloseButton) {
        this.changeInfoWizard('parent')
      } else {
        this.changeInfoWizard(this.csvUpload[page + 1].csvNo)
      }
    },
    /**
     * ストアで WSM 名を取得します。
     */
    getSettingName() {
      const setting = this.getSetting()
      if (setting && setting.data && setting.data.mstSetting) {
        this.wmsName = setting.data.mstSetting.wmsName
        this.isName = setting.data.mstSetting.isName
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .setting-wizard {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    box-shadow: 0px 8px 35px rgba(51, 51, 51, 0.16);
    padding-right: 0 !important;
    margin-right: 0 !important;
    .vld-overlay {
      width: 100vw;
    }
    .btn-check {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 96px;
      height: 45px;
      font-size: 18px;
      font-weight: 700;
      color: #4e66a6;
      border: 1px solid #4e66a6;
      border-radius: 4px;
      background: #ffffff;
      &-status-rcs {
        position: relative;
        width: fit-content;
        &:disabled {
          background: #d6d6d6;
          border: 1px solid #d6d6d6;
          color: #8A8988;
        }
        i {
          position: absolute;
          top: 10px;
          left: 30px;
        }
      }
      &--hover {
        color: #ffffff;
        background-color: #4e66a6;
      }
      &--center {
        margin: 0 auto;
      }
    }
    &__back {
      display: flex;
      align-items: center;
      height: $default-sw-back-height;
      width: 100%;
      background: #ffffff;
      padding: 0;
      border: none;
      font-size: 14px;
      font-weight: 700;
      position: sticky;
      top: 0;
      i {
        font-size: 35px;
        color: #afafae;
        margin-right: 4px;
      }
    }
    &__head {
      height: $default-header-height;
      background-color: #4e66a6;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      overflow: hidden;
      p {
        margin: 0;
        color: #ffffff;
        font-size: 16px;
        font-weight: 700;
      }
      button {
        position: absolute;
        right: 20px;
        width: 24px;
        height: 24px;
        padding: 0;
        color: #ffffff;
        border: none;
        background: none;
        overflow: hidden;
        i {
          width: 24px;
          height: 24px;
          font-size: 24px;
        }
      }
    }
    &__body {
      max-height: calc(100% - #{$default-header-height});
      overflow: auto;
    }
    &__check-setting {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: $default-sw-check-setting-height;
      width: 100%;
      border: none;
      background-color: #f8f8f8;
      padding: 0 20px;
      button {
        display: inline-flex;
        align-items: center;
        color: #4e66a6;
        background-color: #f8f8f8;
        border: none;
        font-size: 16px;
        font-weight: bold;
        .loading {
          animation: rotation 0.5s infinite linear;
          display: none;
        }
      }
      span {
        margin-right: 10px;
      }
      i {
        font-size: 22px;
      }
      &.loading {
        button {
          .loading {
            display: block;
          }
          .loading_done {
            display: none;
          }
        }
      }
    }
    &__check-setting + &__body {
      max-height: calc(100% - #{$default-sw-check-setting-height} - #{$default-header-height});
    }
    &__step {
      .item {
        overflow: hidden;
        &__head {
          height: 56px;
          padding-left: 16px;
          font-size: 14px;
          font-weight: 700;
          background: #ffffff;
          cursor: pointer;
          .num {
            margin-right: 4px;
            flex-shrink: 0;
          }
          .label {
            width: 100%;
            padding-right: 5px;
            @include textOverflowEllipsis(true, 2)
          }
          .check {
            width: 56px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            color: #d6d6d6;
            i {
              display: block;
              width: 30px;
              font-size: 35px;
            }
          }
        }
        &.completed {
          >.item {
            &__head {
              .check {
                background-color: #1fa790;
                color: #ffffff;
              }
            }
          }
        }
        &__body {
          background-color: #f8f8f8;
          padding: 16px 4px 16px 24px;
          p {
            font-size: 12px;
            margin-bottom: 0;
            a {
              color: #4e66a6;
              font-weight: 700;
              text-decoration: underline;
            }
            a.normal {
                font-weight: 400;
              }
          }
          ol {
            padding-left: 14px;
            font-size: 12px;
          }
          h1 {
            font-size: 16px;
            font-weight: 700;
          }
        }
        .explain-click {
          border: 1px solid #d6d6d6;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 12px 16px;
          .text {
            display: flex;
            flex-direction: column;
            align-items: center;
            .red {
              font-size: 12px;
              color: #b41b3e;
            }
            .check {
              display: flex;
              align-items: center;
              font-size: 16px;
              font-weight: 700;
              color: #4e66a6;
              border: 1px solid #ffffff;
              border-radius: 8px;
              i {
                margin-left: 6px;
                font-size: 20px;
              }
            }
          }
          .box-check {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            width: 32px;
            height: 32px;
            background: #1fa790;
            color: #ffffff;
            i {
              color: #ffffff;
              width: 16px;
              font-size: 16px;
              font-weight: bold;
            }
          }
        }
      }
      &--small {
        .item {
          background-color: #f8f8f8;
          &__head {
            height: 32px;
            padding-left: 0;
            font-size: 12px;
            position: relative;
            background-color: #f8f8f8;
            .check {
              width: 32px;
              height: 32px;
              margin-right: 8px;
              i {
                width: 14px;
                font-size: 14px;
                font-weight: bold;
              }
            }
            .arrow {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              right: 16px;
              color: #afafae;
              font-size: 14px;
            }
            &--link {
              .label {
                color: #4e66a6;
                text-decoration: underline;
              }
            }
          }
          &__rcs {
            cursor: default;
          }
        }
      }
    }
    &__help {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #4e66a6;
      height: 54px;
      padding: 0 16px;
      background-color: #f8f8f8;
      &:hover {
        text-decoration: none;
      }
      span {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 16px;
          height: 16px;
          border: 1px solid #4e66a6;
          border-radius: 40px;
          margin-right: 4px;
          font-size: 12px;
        }
      &.loading {
        @include media-breakpoint-x-large() {
          padding: 20px 16px;
        }
      }
    }
    &__child {
      padding: 16px 4px 16px 16px;
      background-color: #f8f8f8;
      h1 {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        .num {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          flex-shrink: 0;
          background: #252422;
          color: #ffffff;
          font-size: 20px;
          font-weight: bold;
          margin-right: 8px;
          &--outline {
            background: transparent;
            border: 2px solid #252422;
            color: #252422;
          }
        }
      }
      p {
        font-size: 12px;
        margin-bottom: 16px;
        word-break: break-all;
      }
      a {
        color: #4e66a6;
        font-weight: 700;
        text-decoration: underline;
      }
      .sub-title {
        font-size: 14px;
        font-weight: 700;
        margin-bottom: 0px;
      }
    }
    .wizard-info {
      height: calc(100vh - #{$default-header-height} - #{$default-sw-back-height});
    }
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/custom-components/DetailSettingWizard.vue